module.exports = __webpack_public_path__ + "img/de.miele.infocontrol.928b02d5.webp";